import { Card } from '@/components/ui/card';
import { Building } from 'lucide-react';

export default function Administrativo({ user, onLogout }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Card className="p-12 text-center">
        <Building className="w-16 h-16 mx-auto text-gray-400 mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Módulo Administrativo</h2>
        <p className="text-gray-600">Este módulo estará disponible próximamente</p>
      </Card>
    </div>
  );
}
